// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__aHbgJ","total":"MasterSaleDetails_total__QPpEm","edit":"MasterSaleDetails_edit__oaRqY","cancel":"MasterSaleDetails_cancel__zpkFB"};